import { render, staticRenderFns } from "./Excel2BPDocumentation.vue?vue&type=template&id=c7dd4e74"
import script from "./Excel2BPDocumentation.vue?vue&type=script&lang=js"
export * from "./Excel2BPDocumentation.vue?vue&type=script&lang=js"
import style0 from "./Excel2BPDocumentation.vue?vue&type=style&index=0&id=c7dd4e74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports